<template>
  <div class="print-table">
    <table border="1" cellspacing="0" cellpadding="0" width="698.5">
      <tr align="center">
        <td colspan="8" class="caption" height="40">{{info.supplier}}</td>
      </tr>
      <tr>
        <td colspan="3" width="50%" height="40">接收单位：多多买菜</td>
        <td colspan="5">供货方：{{info.supplier}}</td>
      </tr>
      <tr>
        <td colspan="3" height="50">接收地址：福建省福州市闽侯县青口镇船尾村吉山路5号福州中瑞铝业有限公司1#厂房 多多买菜仓库</td>
        <td colspan="5">供货方地址：{{info.address}}</td>
      </tr>
      <tr>
        <td colspan="8" height="40">联系电话：{{info.telephone}}</td>
      </tr>
      <tr align="center">
        <td width="5.8%" height="40">序号</td>
        <td>商品名称</td>
        <td width="11%">单位/规格</td>
        <td>箱规</td>
        <td>件数</td>
        <td>实发数量</td>
        <td>生产日期</td>
        <td>保质期</td>
      </tr>
      <slot name="goods"></slot>
      <tr>
        <td colspan="8">
          <div style="width:100%;height:100%;overflow:auto"></div>
        </td>
      </tr>
      <!--<tr align="center" v-for="(item, index) in taskPrintBillGoodList" :key="index">-->
        <!--<td>{{index + 1}}</td>-->
        <!--<td>{{item.name}}</td>-->
        <!--<td>{{item.standard}}</td>-->
        <!--<td>{{item.box}}</td>-->
        <!--<td>-->
          <!--{{parseInt(item.num / item.box)}}<span v-if="(item.num % item.box) > 0">+{{(item.num % item.box)}}</span>-->
        <!--</td>-->
        <!--<td>{{item.actualNum}}</td>-->
        <!--<td></td>-->
        <!--<td></td>-->
      <!--</tr>-->
      <tr>
        <td colspan="8" height="40">注：福建省工商行政管理机关提示：该供货凭证可作为进货台账，请注意保存2年</td>
      </tr>
      <tr>
        <td colspan="8" height="40">
          <div class="bottom">
            <span>送货日期：{{today}}</span>
            <span>审批：</span>
            <span>电话：</span>
            <span>客户（签收）：</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'printTable',
  data () {
    return {
      today: null
    }
  },
  props: ['info'],
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getToDay()
  },
  methods: {
    getToDay () {
      let now = new Date()
      let nowYear = now.getFullYear()
      let nowMonth = now.getMonth()
      let nowDate = now.getDate()
      nowMonth = this.doHandleMonth(nowMonth + 1)
      nowDate = this.doHandleMonth(nowDate)
      this.today = nowYear + '-' + nowMonth + '-' + nowDate
    },
    doHandleMonth (month) {
      if (month.toString().length === 1) {
        month = '0' + month
      }
      return month
    }
  }
}
</script>

<style scope>
  .print-table table {
    margin: 0 auto;
    border-collapse: collapse;
    font-size: 14px;
    /*height: 500.5px;*/
    height: 400.5px;
  }

  .print-table table .caption {
    font-size: 24px;
    font-weight: 500;
  }

  .print-table table td {
    padding: 0 5px;
    box-sizing: border-box;
  }

  .print-table table td .bottom {
    display: flex;
    justify-content: space-between;
    padding-right: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/PrintTable.vue